import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import {
  ADVANCED_ORDER_TYPE_LABELS,
  ADVANCED_ORDER_TYPES,
  isTriggerOrderType,
} from '@/constants/advancedOrder';

import { useAdvancedOrderType } from '@/hooks/useAdvancedOrderType';

import { buttons } from '@/styles/buttons';
import { popover } from '@/styles/popover';
import { fontStyles } from '@/styles/typography';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { ChevronDownIcon } from '@/ui/Icons/ChevronDownIcon';

export function OrderTypeDropDownMenu() {
  const [orderType, setAdvancedOrderType] = useAdvancedOrderType();
  const { base: popoverStyles, item: popoverItemStyles } = popover();

  return (
    <div className="flex flex-col justify-center py-4 px-6">
      <div className="flex justify-between items-center">
        <p className={fontStyles({ variant: 'LABEL_MD' })}>Order type</p>
        <DropdownMenu.Root modal={false}>
          <DropdownMenu.Trigger
            className={buttons({
              size: 'small',
              color: 'alphaGray',
              shape: 'rounded',
              class:
                'justify-between gap-1 m-0 px-2.5 min-w-[143px] rounded-sm before:content-none after:content-none',
            })}
          >
            <span className={fontStyles({ variant: 'LABEL_MD' })}>
              {ADVANCED_ORDER_TYPE_LABELS[orderType]}
            </span>
            <span className="flex justify-center">
              <ChevronDownIcon />
            </span>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content className={popoverStyles({ class: 'mt-0' })} sideOffset={8}>
              {ADVANCED_ORDER_TYPES.filter(isTriggerOrderType).map((type) => (
                <DropdownMenu.Item
                  key={type}
                  className={popoverItemStyles()}
                  onSelect={() => setAdvancedOrderType(type)}
                >
                  <span className={fontStyles({ variant: 'BODY_SM' })}>
                    {ADVANCED_ORDER_TYPE_LABELS[type]}
                  </span>
                  {type === orderType ? <CheckmarkIcon className="ml-auto" /> : null}
                </DropdownMenu.Item>
              ))}
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </div>
      <p className={fontStyles({ variant: 'BODY_SM', class: 'text-token-gray-800 mt-3' })}>
        {ADVANCED_ORDER_TYPE_LABELS[orderType]} is a trigger order that fires a{' '}
        <b className="font-bold">market swap</b> once your target price is reached. Actual trade
        output depends on market conditions.
      </p>
    </div>
  );
}
